import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Marquee from "../common/Marquee";
import Header from "../common/Header";
import Subscribe from "../common/Subscribe";
import Footer from "../common/Footer ";
import FaqSection from "../common/FaqSection ";
import ContactFormSection from "../../pages/home/ContactFormSection";
import VirtualOfficeSection from "../../pages/home/VirtualOfficeSection";

export default function Layout() {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

   useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) {
        element.scrollIntoView({ behavior: "smooth" });

        setTimeout(() => {
        window.history.replaceState(null, "", window.location.pathname);
      }, 500);
      }
    }
  }, [location]);

  return (
    <div className="w-full h-screen bg-[#ffffff]">
      {/* Marquee */}
      <Marquee />
      <Header />

      <main className="w-full">
        <Outlet />
      </main>

      <div id="bookfreeguidance">
        <VirtualOfficeSection />
      </div>
      
      {/* <FaqSection /> */}
      {/* Contact form only shows on home page */}
      {isHomePage &&
        <div id="contact">
          <ContactFormSection />
        </div>
      }
      <Subscribe />

      {/* Footer */}
      <Footer />
    </div>
  );
}
